import React, { useRef, useState } from 'react'
import "./navbar.css"
import theme_pattern from "../../assets/theme_pattern.svg"
import underLine from "../../assets/nav_underline.svg"
import AnchorLink from 'react-anchor-link-smooth-scroll';
import menu_open from "../../assets/menu_open.svg"
import menu_close from "../../assets/menu_close.svg"
const Navbar = () => {
  const [menu, setMenu] = useState("home");
  const menuRef = useRef();

  const openMenu = ()=>{
    menuRef.current.style.right = "0";
  }
  
  const closeMenu = ()=>{
    menuRef.current.style.right = "-350px";
  }

  return (
    <nav id='nav' className="navbar">
      <div className="name">
      <h1>GOWTHAM G</h1>
      <img src={menu_open} onClick={openMenu} alt="" className="menu nav-open" />
      </div>
      <img src={theme_pattern} alt="theme" className='theme'/>
      <ul ref={menuRef} className="nav-menu">
        <img src={menu_close} onClick={closeMenu} alt="" className="menu nav-close" />
        <li><AnchorLink className="anchor-link"  href="#nav"> <p onClick={()=>setMenu("home")}>Home</p></AnchorLink>{menu === "home" ? <img src={underLine} alt="" className='underline'/> :<></>}</li>
        <li><AnchorLink className="anchor-link" offset={50} href="#about"><p onClick={()=>setMenu("about")}>About</p></AnchorLink>{menu === "about" ? <img src={underLine} alt=""  className='underline' /> :<></>}</li>
        <li><AnchorLink className="anchor-link" offset={50} href="#services"><p onClick={()=>setMenu("services")}>Expertise</p></AnchorLink>{menu === "services" ? <img src={underLine} alt=""  className='underline'/> :<></>}</li>
        <li><AnchorLink className="anchor-link" offset={50} href="#work"><p onClick={()=>setMenu("work")}>Projects</p></AnchorLink>{menu === "work" ? <img src={underLine} alt=""  className='underline'/> :<></>}</li>
        <li><AnchorLink className="anchor-link" offset={50} href="#contact"><p onClick={()=>setMenu("contact")}>Contact</p></AnchorLink>{menu === "contact" ? <img src={underLine} alt=""  className='underline'/> :<></>}</li>
      </ul>
      <div className="nav-connect"><AnchorLink className="anchor-link" offset={50} href="#contact">
        Connect With Me</AnchorLink>
      </div>
    </nav>
  )
}

export default Navbar
